import { render, staticRenderFns } from "./lost.vue?vue&type=template&id=8b7753c2&scoped=true&"
import script from "./lost.vue?vue&type=script&lang=js&"
export * from "./lost.vue?vue&type=script&lang=js&"
import style0 from "./lost.vue?vue&type=style&index=0&id=8b7753c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7753c2",
  null
  
)

export default component.exports